import {
  COOKIE_CHANNEL_NAME,
  COOKIE_IS_TEMPORARY_CHANNEL,
  DEFAULT_CHANNEL,
  fixedChannelHosts,
  QUERY_CHANNEL_NAME,
  QUERY_CHANNEL_NAME_TEMPORARY
} from "@website/utils/channel/constants";
import { getChannel } from "@website/utils/channel/get-channel";
import { getCookie, setCookie } from "@website/utils/cookie";
import { isSSR } from "@website/utils/is-ssr";

export const setChannel = () => {
  if (isSSR() || getCookie(COOKIE_IS_TEMPORARY_CHANNEL)) return;
  const queryParameters = new URLSearchParams(window.location.search);
  const fixedChannel = fixedChannelHosts[window.location.hostname];
  const queryChannel = queryParameters.get(QUERY_CHANNEL_NAME);
  const temporaryChannel = queryParameters.get(QUERY_CHANNEL_NAME_TEMPORARY);

  const cookieOptions = {
    path: "/",
    sameSite: "lax" as const,
    httpOnly: false,
    secure: window.location.protocol === "https:"
  };

  const channel =
    fixedChannel ||
    queryChannel ||
    temporaryChannel ||
    getChannel() ||
    DEFAULT_CHANNEL;

  let maxAge = 60 * 60 * 24 * 7; // 7 روز
  if (
    ["safarmarket"].includes(channel) || // temporary (it can be removed in 26 Oct 2026)
    (!fixedChannel && !queryChannel && temporaryChannel)
  ) {
    maxAge = 60 * 30; // 30 دقیقه
    setCookie(COOKIE_IS_TEMPORARY_CHANNEL, "true", {
      ...cookieOptions,
      maxAge
    });
  }

  document.querySelector("html")?.classList.add(channel);
  setCookie(COOKIE_CHANNEL_NAME, channel, {
    ...cookieOptions,
    maxAge
  });
};
